<template>
  <team-grid :userTeams="userTeams"></team-grid>
</template>

<script>
import TeamGrid from '@/components/Team/TeamGrid';
import PropertyAssessmentType from '@/services/Property/PropertyAssessmentType';

export default {
  name: "TeamManagement",
  components: {
    TeamGrid,
  },
  data() {
    return {
      userTeams: [],
    };
  },
  computed: {
    hasUserTeams() {
      return !!(this.userTeams.length);
    },
  },
  created() {
    this.setUserTeams();
  },
  mounted() {
    this.$store.dispatch('fetchUser');

    // Get results for FIRE RISK only
    this.$store.dispatch('refreshCounts', PropertyAssessmentType.COMPLIANCE_TYPE_FIRE_ID());
  },
  methods: {
    setUserTeams() {
      const user = this.$store.getters.authUser;
      const { teams } = user;

      this.userTeams = teams;
    },
  },
}
</script>

<style scoped>

</style>
